import React, { memo } from 'react';

import { Checkbox as AntCheckbox, Col } from 'antd';

import type { Action, GroupModule } from 'v2/interfaces/access-control';

type Props = {
  action: Action;
  module: GroupModule;
  handleActionsChange: (action: Action, checked: boolean) => void;
  isChecked: boolean;
  isDisabled: boolean;
};

function Checkbox({ action, handleActionsChange, isChecked, isDisabled }: Props) {
  return (
    <Col xs={24} sm={12}>
      <AntCheckbox
        id={`${action.fullname}-${action.module_id}`}
        checked={isChecked}
        onChange={e => handleActionsChange(action, e.target.checked)}
        disabled={isDisabled}
      >
        {action.name}
      </AntCheckbox>
    </Col>
  );
}

export default memo(Checkbox);
